const environment = {
    apiAuthAgentUrl: "http://localhost:8080/auth",
    apiAuthCustomerUrl: "http://localhost:8080/auth-customer",
}

export default environment;
